import angular from 'angular';
import IdentityBarComponent from './identity-bar.component.js';

const IdentityBarModule = angular
    .module('control-room.commons.layout.components.identity-bar', [])
    .component('crIdentityBar', IdentityBarComponent);

export default IdentityBarModule;
